import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { LogoExploration } from './pages/LogoExploration';
export function AppRouter() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<App data-id="element-11" />} data-id="element-10" />
        <Route path="/logos" element={<LogoExploration data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}